import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const SidebarContext = createContext(null);

const STORAGE_KEY = 'sidebar_collapsed';

export function SidebarProvider({ children }) {
    const [collapsed, setCollapsed] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    });

    const toggle = useCallback(() => {
        setCollapsed(prev => {
            const next = !prev;
            try { localStorage.setItem(STORAGE_KEY, String(next)); } catch { /* noop */ }
            return next;
        });
    }, []);

    const expand = useCallback(() => {
        setCollapsed(false);
        try { localStorage.setItem(STORAGE_KEY, 'false'); } catch { /* noop */ }
    }, []);

    const collapse = useCallback(() => {
        setCollapsed(true);
        try { localStorage.setItem(STORAGE_KEY, 'true'); } catch { /* noop */ }
    }, []);

    return (
        <SidebarContext.Provider value={{ collapsed, toggle, expand, collapse }}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    const ctx = useContext(SidebarContext);
    if (!ctx) throw new Error('useSidebar must be used within SidebarProvider');
    return ctx;
}
